import { Text } from '@dixa/lib-shared-habla';

import { CopilotFeaturesRow } from './copilotFeaturesRow/copilotFeaturesRow';
import { CopilotMotivation } from './copilotMotivation/copilotMotivation';

export const FeaturesSection = (): JSX.Element => {
  return (
    <>
      <Text.Paragraph>
        The Agent Co-pilot bundle empowers your team with cutting edge AI
        features, optimizing customer interactions
      </Text.Paragraph>
      <CopilotFeaturesRow />
      <CopilotMotivation />
    </>
  );
};
